// @ts-ignore
import { installPinia } from '@/pinia'
import { setupAppWithGlobalDependencies } from '@/setup'

import { createApp } from 'vue'
import './main.scss'

// @ts-ignore
import ApplicationInstance from './App.vue'

import '@fontsource/inter'
import 'floating-vue/dist/style.css'
// v-calendar layout/theme globals. Loaded eagerly so every consumer of
// the v-calendar DatePicker gets correct grid layout regardless of which
// route mounts first. See comment in v-calendar.css for rationale.
import './v-calendar.css'

const initializedApp = createApp(ApplicationInstance)
const appWithDependencies = setupAppWithGlobalDependencies(initializedApp)
appWithDependencies.mount('#app')